import { useEffect, useState } from "react";
import api from "../../services/api";
import "./Accolades.css";

const Accolades = () => {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetchAccolades();
  }, []);

  const fetchAccolades = async () => {
    try {
      const res = await api.get("api/accolades");
      if (res.data?.status) {
        setSections(res.data.data || []);
      }
    } catch (error) {
      console.error("Failed to fetch accolades", error);
    } finally {
      setLoading(false);
    }
  };

  const AccoladesSkeleton = () => (
    <section className="progress-section accolade-section pb-5">
      <div className="container">
        <div className="py-5 text-center skeleton">
          <div className="skeleton-line medium shimmer mx-auto"></div>
        </div>
        <div className="row justify-content-center">
          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((i) => (
            <div key={i} className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="skeleton p-4 text-center">
                <div
                  className="shimmer mb-3 mx-auto"
                  style={{
                    width: "150px",
                    height: "150px",
                    borderRadius: "50%",
                    background: "#e0e0e0",
                  }}
                ></div>
                <div className="skeleton-line medium shimmer mx-auto"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );

  if (loading) return <AccoladesSkeleton />
  if (!sections.length) return null;

  return (
    <>
      <section className="progress-section accolade-section pb-5">
        <div className="container">
          {sections.map((section) => (
          <div key={section.id}>
            <div className="py-5 text-center">
              <h2 className="section-title">{section.section_title}</h2>
            </div>

            <div className="row justify-content-center">
              {section.accolades.map((item, index) => (
                <div key={index} className="col-lg-4 col-md-6 col-12 mb-4">
                  <div className="single-accolade">
                    <div className="img-wrapper">
                      <img
                        src={item.icon}
                        className="img-fluid"
                        alt={item.title}
                      />
                    </div>
                    <div className="content">
                      <p>{item.title}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default Accolades;
